import PosaTemplate from './PosaTemplate';
import PropTypes from 'prop-types';
import React from 'react';
import RichTextStyled from './RichTextStyled';

const RichText = ({data}) => {
  const {content} = data;
  if (!content) return null;
  return (
    <RichTextStyled className="ecr-rich-text">
      <PosaTemplate isTemplate string={content} />
    </RichTextStyled>
  );
};

RichText.propTypes = {
  data: PropTypes.object,
};

export default RichText;
